import { InjectionToken } from '@angular/core';

export const FORM_METADATA_RELATIVE_PATH_TOKEN = new InjectionToken<string>('@farris/form_metadata_relative_path');
